module.exports = __webpack_public_path__ + "static/media/pricingIcon.2f57be1f.svg";